import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { Button } from '@/components/atoms/Button/Button'
import { RichTextField } from '@/components/organisms/RichTextField/RichTextField'
import { CTAProps } from './types'

export function CTASection({ pageContent, instance, ...props }: CTAProps) {
  const { content } = pageContent?.blok || instance || {}
  const { heading, body, background_image, buttons, variant = 'default', layout = 'vertical' } = content || props
  const isVertical = layout === 'vertical' || !layout

  return (
    <section
      style={{ backgroundImage: `url(${background_image?.image})` }}
      className={clsx('bg-center relative', {
        'bg-primary-700': variant === 'default',
        'bg-primary-100': variant === 'light'
      })}
      id={kebabCase(heading)}
    >
      <div
        className={clsx('flex flex-col px-24 py-48 gap-24 mx-auto laptop:px-90  netbook:py-64 max-w-screen-desktop', {
          'smartphone:items-center smartphone:text-center': isVertical,
          'netbook:flex-row netbook:items-center netbook:justify-between': layout === 'horizontal'
        })}
      >
        <div
          className={clsx(' flex flex-col', {
            'text-white': variant === 'default',
            'text-text-brand-darker': variant === 'light',
            'smartphone:items-center smartphone:text-center max-w-screen-netbook': isVertical,
            'max-w-38 lg:max-w-44': layout === 'horizontal'
          })}
        >
          <h2 className="text-headingM-mobile netbook:text-headingM font-bold mb-24 font-poppins">{heading}</h2>
          <div
            className={clsx('leading-loose text-bodyL font-normal ', {
              'smartphone:text-center': isVertical,
              'netbook:max-w-lg [&_span]:text-balance': layout === 'horizontal'
            })}
          >
            {typeof body === 'string' ? body : <RichTextField data={body} />}
          </div>
        </div>
        <div
          className={clsx('w-full z-10 flex gap-16 netbook:gap-24', {
            'flex-col smartphone:w-auto smartphone:flex-row smartphone:justify-center smartphone:items-center smartphone:text-center':
              isVertical,
            'flex-col netbook:flex-row netbook:w-auto netbook:items-center': layout === 'horizontal'
          })}
        >
          {buttons &&
            buttons?.length > 0 &&
            buttons.map((button) => (
              <Button
                key={button._uid}
                {...button}
                theme={button.theme}
                className={clsx('w-full netbook:w-auto text-nowrap', { 'smartphone:w-auto': isVertical })}
              >
                {button.text}
              </Button>
            ))}
        </div>
      </div>
    </section>
  )
}
